import CustomSegment from "../../../../components/CustomSegment";
import PageTitle from "../../../../components/PageTitle";
import { useSegment } from "../../../../hooks/useSegment";
import DashboardLayout from "../../../../layouts/DashboardLayout";
import type { SegmentedType } from "../../../../types/global.types";
import LeaveRequest from "./_components/LeaveRequest/LeaveRequest";
import LeaveRequestFilter from "./_components/LeaveRequest/LeaveRequestFilter";
import LeaveSummery from "./_components/LeaveSummery/LeaveSummery";
import LeaveSummeryEvents from "./_components/LeaveSummery/LeaveSummeryEvents";
import LeaveSummeryFilter from "./_components/LeaveSummery/LeaveSummeryFilter";

type SegmentType = "leave_summery" | "leave_request";

const EmpLeave = () => {
  const { segment, setSegment } = useSegment<SegmentType>(
    "emp-leave-segment",
    "leave_summery",
    true,
  );

  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      value: "leave_summery",
      label: "Summary",
      view: <LeaveSummery />,
    },
    {
      value: "leave_request",
      label: "Leave Request & Approval",
      view: <LeaveRequest />,
    },
  ];

  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Leave">
      <PageTitle
        classNames={{ root: "items-start" }}
        title="Leave"
        items={[
          { title: "Dashboard", path: "/admin/employee/dashboard" },
          { title: currentSegment?.label },
        ]}
      >
        <div>
          {currentSegment?.value === "leave_summery" && <LeaveSummeryFilter />}
          {currentSegment?.value === "leave_summery" && <LeaveSummeryEvents />}
        </div>
        {currentSegment?.value === "leave_request" && <LeaveRequestFilter />}
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />

      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default EmpLeave;
